import React from 'react';
import { RadioProps, useRadio } from '@chakra-ui/react';
import cx from 'clsx';

import styles from './RadioTab.module.scss';

export interface IRadioTabProps extends RadioProps {
    icon?: React.ReactNode;
    shrink?: boolean;
}

export const RadioTab: React.FC<IRadioTabProps> = ({ icon, shrink, ...props }) => {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const radioProps = getRadioProps();

    let _icon: React.ReactElement | null = null;

    if (icon) {
        _icon = <span className={styles.icon}>{icon}</span>;
    }

    return (
        <label className={styles.label}>
            <input {...input} />
            <div {...radioProps} className={cx(styles.radio, { [styles.shrink]: shrink })}>
                {_icon}
                <span className={styles.text}>{props.children}</span>
            </div>
        </label>
    );
};
